import { useInfiniteQuery } from '@tanstack/react-query';
import { getNextPageParam } from './hooksUtils';

export const useInfiniteQueryData = (queryKey: any, queryFn: any, options: any = {}, isLarge = false) => {
  return useInfiniteQuery({
    queryKey,
    queryFn,
    initialPageParam: 1,
    ...Object.assign(
      {
        getNextPageParam: (lastPage: any, pages: any) => getNextPageParam(lastPage, pages, isLarge)
      },
      options
    )
  });
};
